import { SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

const styles = {
  modalWrap: {
    top: "20px",
    bottom: "20px",
  },
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      lg: "80%",
    },
    height: "100%",
    outline: "none",
    bgcolor: "background.modalBg",
    borderRadius: "10px",
    p: "20px",
    overflowY: "auto",
  } as SxProps<Theme>,
  modalContent: {
    width: "100%",
    height: "100%",
  },
  modalIconClose: {
    position: "absolute",
    zIndex: 1400,
    top: {
      xs: 2,
      md: 5,
    },
    right: {
      xs: 3,
      md: 5,
    },
    p: {
      xs: 0,
      md: "8px",
    },
  },
};

export default styles;
